import React from "react";

import {ThemeContext} from "@/contexts/ThemeContext";
import RenderIf from "@/components/Global/RenderIf/RenderIf";
import {config} from "@/config";

import styles from "./EdgeLoading.module.scss";

export default function EdgeLoading({showMessage, loadingScreenMsg}) {
  return (
    <div className={`${styles.content}`}>
      <div className={`${styles.edgeContainer}`}>
        <div className={`${styles.edgeAnimation}`}>
          <span className={styles.shape}></span>
          <span className={styles.shape}></span>
          <span className={styles.shape}></span>
          <span className={styles.shape}></span>
          <span className={styles.shape}></span>
          <span className={styles.shape}></span>
          <span className={styles.shape}></span>
        </div>
      </div>

      <RenderIf isTrue={loadingScreenMsg !== ""}>
        <p className={`text-center ${styles.loading} mt-4 fs-2`}>{loadingScreenMsg}</p>
      </RenderIf>
      <RenderIf isTrue={loadingScreenMsg === ""}>
        <p className={`text-center ${styles.loading} mt-4 fs-2`}>Loading dashboard</p>
        <RenderIf isTrue={showMessage}>
          <p className={`fs-6 text-center px-5 ${styles.loadingInfo}`}>
            Please wait, we are still loading your dashboard
          </p>
        </RenderIf>
      </RenderIf>
    </div>
  );
}
